import { laptop } from "@/App/breakpoints";
import "./style.css";

export default class FiltersHeader {
  static selector = ".filters-header";

  constructor(block) {
    this.block = block;

    this.lastScroll = 0;
    this.scrollY = 0;

    this.filtersWrapper = this.block.querySelector(".filters-header__inner");
    this.filtersToggle = this.block.querySelector(".filters-header__toggle");

    this.filterTopic = this.block.querySelector("select[name='apGridTopic']");
    this.filterTopicWrapper = this.filterTopic.parentNode.parentNode;
    this.filterTopicLabel = this.filterTopicWrapper.querySelector(
      ".select__label"
    );

    this.filterDateFrom = this.block.querySelector(
      "input[name='apGridDateFrom']"
    );
    this.filterDateFromWrapper = this.filterDateFrom.parentNode.parentNode;
    this.filterDateFromLabel = this.filterDateFromWrapper.querySelector(
      ".select__label"
    );

    this.filterDateTo = this.block.querySelector("input[name='apGridDateTo']");
    this.filterDateToWrapper = this.filterDateTo.parentNode.parentNode;
    this.filterDateToLabel = this.filterDateToWrapper.querySelector(
      ".select__label"
    );

    this.filtersReset = this.block.querySelector(
      ".filters-header__actions-button--reset-all"
    );
    this.filtersApply = this.block.querySelector(
      ".filters-header__actions-button--apply"
    );

    this.isMobile = null;

    this.updateSelectPlaceholders();
  }

  closeFilters = () => {
    document.body.classList.remove("filters-header-open");
  };

  updateSelectPlaceholders = () => {
    const isMobile = window.innerWidth < laptop;

    if (this.isMobile === null) {
      this.isMobile = !isMobile;
    }

    if (!this.isMobile && isMobile) {
      this.filterTopicWrapper.setAttribute("data-placeholder", "Select topic");
      this.filterTopicLabel.innerText = "Select topic";
      this.filterDateFromWrapper.setAttribute("data-placeholder", "dd/mm/yyyy");
      this.filterDateFromLabel.innerText = "dd/mm/yyyy";
      this.filterDateToWrapper.setAttribute("data-placeholder", "dd/mm/yyyy");
      this.filterDateToLabel.innerText = "dd/mm/yyyy";
    } else if (this.isMobile && !isMobile) {
      this.filterTopicWrapper.setAttribute("data-placeholder", "Topic");
      this.filterTopicLabel.innerText = "Topic";
      this.filterDateFromWrapper.setAttribute("data-placeholder", "From");
      this.filterDateFromLabel.innerText = "From";
      this.filterDateToWrapper.setAttribute("data-placeholder", "To");
      this.filterDateToLabel.innerText = "To";
    }

    this.isMobile = isMobile;
  };

  // Event handlers
  onFiltersToggleClick = () => {
    document.body.classList.toggle("filters-header-open");
  };
  onFiltersReset = () => {
    this.filterTopic.value = "";
    this.filterDateFrom.value = "";
    this.filterDateTo.value = "";
  };

  // Public
  onReady = () => {
    this.filtersToggle?.addEventListener("click", this.onFiltersToggleClick);
    this.filtersReset?.addEventListener("click", this.onFiltersReset);
    this.filtersApply?.addEventListener("click", this.closeFilters);
  };
  onDestroy = () => {
    this.filtersToggle?.removeEventListener("click", this.onFiltersToggleClick);
    this.filtersReset?.removeEventListener("click", this.onFiltersReset);
    this.filtersApply?.removeEventListener("click", this.closeFilters);
  };
  onResize() {
    this.closeFilters();
    this.updateSelectPlaceholders();
  }

  onScroll() {}
}
